let UserMenuId = {
    TABLE: 0,
    MY_INFO: 1,
    LESSON_HISTORY: 2,
    PAYMENT_HISTORY: 3,
    text: ["레슨 시간표", "내 정보", "레슨 내역", "결제 내역"]
}
export default UserMenuId;
